<div style="display:none" [innerHTML]="stylesheet"></div>